import 'tippy.js/dist/tippy.css';
import classNames from 'classnames';

import { msg } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';
import { MapPinned, Trophy } from 'lucide-react';
import { ChampionshipStatus } from 'modules/championship/domain/enums/championship-status';
import { ChampionshipListItem } from 'modules/championship/domain/interfaces/championship-list-item';
import { ChampionshipEncoded } from 'modules/championship/domain/interfaces/championship-encoded';
import React, { useCallback } from 'react';
import type { MessageDescriptor } from 'shared/i18n';
import UDText from 'ud-ui/components/text';

import { DivProps } from 'typings';

import * as S from './styles';
import { UDTippy } from 'ud-ui/components';

type Props = {
  // championship: ChampionshipEncoded;
  championship: ChampionshipListItem;
  containerProps?: Omit<DivProps, 'children' | 'onClick'>;
  onClickCard: (id: ChampionshipEncoded['id']) => any;
};

const statusIndicatorMessage: Record<ChampionshipStatus, MessageDescriptor> = {
  [ChampionshipStatus.OPEN]: msg`Прием заявок открыт`,
  [ChampionshipStatus.CLOSE]: msg`Прием заявок закрыт`,
};

const ChampionshipCard = (props: Props) => {
  const { t, i18n } = useLingui();
  const start = props.championship.startDate ? new Date(props.championship.startDate).toLocaleDateString(i18n.locale) : null;
  const end = props.championship.endDate ? new Date(props.championship.endDate).toLocaleDateString(i18n.locale) : null;

  const onClickCard = useCallback(() => {
    props.onClickCard(props.championship.id);
  }, [props]);

  return (
    <S.CardContainer
      {...props.containerProps}
      className={classNames('flex flex-col py-4 pr-4 pl-3', props.containerProps?.className)}
      onClick={onClickCard}
    >
      <div className="mb-5 flex flex-row items-center">
        <Trophy size={16} className="mr-1" />
        <UDText type="caption-2" className="text-surfaceRomanSilver30">
          <Trans>Турнир</Trans>
        </UDText>
        <MapPinned size={16} className="text-surfaceRomanSilver30 mr-1 ml-auto" />
        <UDText type="caption-2" className="text-surfaceRomanSilver30">
          {props.championship.address?.city}
        </UDText>
      </div>
      <S.StyledTournamentName type="subhead" className="bold">
        {props.championship.name}
      </S.StyledTournamentName>
      <div className="mt-auto flex flex-row items-center justify-between">
        <UDText type="subhead" className="date text-surfaceRichBlack60">
          {start} —{' '}
          {end || (
            <span className="text-surfaceRomanSilver30">
              <Trans>открытая дата</Trans>
            </span>
          )}
        </UDText>
        <UDTippy
          content={t(statusIndicatorMessage[props.championship?.status ?? ChampionshipStatus.CLOSE])}
          placement="right"
          interactive={false}
        >
          <S.StatusIndicator data-status={props.championship?.status} />
        </UDTippy>
      </div>
    </S.CardContainer>
  );
};

export default ChampionshipCard;
